var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('envelopes-show-page',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var envelope = ref.item;
var itemDisabled = ref.itemDisabled;
return [_c('tunnel',{attrs:{"value":envelope},on:{"input":_vm.handleEnvelopeUpdate}}),(!!envelope)?_c('envelope-slip',{attrs:{"envelope":envelope}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }